export default "__VITE_ASSET__2d3f229f__"